import type { CSSProperties } from 'react';
import type { NoteFigure } from '../types';
import { FigureIcon } from './FigureIcon';

interface Props {
  figure: NoteFigure;
  hit: boolean;
  active: boolean;
  compact?: boolean;
  accentColor: string;
  onClick: () => void;
}

export function RhythmCell({
  figure,
  hit,
  active,
  compact,
  accentColor,
  onClick,
}: Props) {
  return (
    <button
      type="button"
      className={`rhythm-cell ${hit ? 'rhythm-cell--hit' : ''} ${active ? 'rhythm-cell--active' : ''} ${compact ? 'rhythm-cell--compact' : ''}`}
      onClick={onClick}
      aria-label={`${hit ? 'Tocar' : 'Silencio'}, ${figure}`}
      style={
        {
          '--rhythm-accent': accentColor,
          '--rhythm-glow': `${accentColor}55`,
        } as CSSProperties
      }
    >
      <span className="rhythm-cell__halo" aria-hidden="true" />
      <span className="rhythm-cell__body" aria-hidden="true">
        <FigureIcon
          figure={figure}
          filled={hit}
          size={compact ? 30 : 38}
          color={hit ? accentColor : '#607D8B'}
        />
      </span>
    </button>
  );
}
